import { CenterFormFields } from 'src/constants/centers';
import { HospitalInfo } from './HospitalInfo';
import { HospitalLessonsDuration } from './HospitalLessonsDuration';
import { HospitalWorkingHours } from './HospitalWorkingHours';
import { getSchoolLessons } from 'src/utils/centers';
import { ArrayInput, FormDataConsumer, SimpleFormIterator, BooleanInput } from 'react-admin';
import { disableFirstRemoveStyle, formIteratorStyles } from 'src/styles';
import { ShsButton } from 'src/components/common';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export const HospitalWorkingInfo: React.FC = () => {
    return (
        <ArrayInput source={CenterFormFields.HOSPITALS} label="">
            <SimpleFormIterator
                disableClear
                disableReordering
                fullWidth
                sx={{
                    ...disableFirstRemoveStyle,
                    ...formIteratorStyles
                }}
                addButton={
                    <ShsButton
                        styleType="outline-no-border"
                        sx={{ paddingLeft: '0 !important' }}
                        label="Додати лікарню"
                        icon={<AddCircleOutlineIcon sx={{ fontSize: '24px !important' }} />}
                    />
                }>
                <FormDataConsumer>
                    {({ getSource }) => {
                        const src = getSource(CenterFormFields.HOSPITALS) ?? '';
                        const hospitalIndex = Number(src.match(/\d+/)?.[0]) || 0;
                        return (
                            <>
                                <HospitalInfo getSource={getSource} />
                                <HospitalWorkingHours getSource={getSource} />
                                <BooleanInput
                                    source={getSource(CenterFormFields.ACTIVE)}
                                    sx={{ display: 'none' }}
                                    label="Активний"
                                    defaultValue={true}
                                />
                                <HospitalLessonsDuration
                                    educationalLevel="Дошкільна освіта"
                                    lessonDurationSource={getSource(
                                        `${CenterFormFields.LESSONS_DURATION}.${CenterFormFields.BEFORE_SCHOOL_EDUCATION}.${CenterFormFields.LESSON_DURATION}`
                                    )}
                                    schoolLessons={getSchoolLessons(
                                        CenterFormFields.BEFORE_SCHOOL_EDUCATION,
                                        hospitalIndex
                                    )}
                                    isTitleShown
                                />
                                <HospitalLessonsDuration
                                    educationalLevel="1-4 класи"
                                    lessonDurationSource={getSource(
                                        `${CenterFormFields.LESSONS_DURATION}.${CenterFormFields.FIRST_FOURTH_GRADE}.${CenterFormFields.LESSON_DURATION}`
                                    )}
                                    schoolLessons={getSchoolLessons(CenterFormFields.FIRST_FOURTH_GRADE, hospitalIndex)}
                                />
                                <HospitalLessonsDuration
                                    educationalLevel="5-11 класи"
                                    lessonDurationSource={getSource(
                                        `${CenterFormFields.LESSONS_DURATION}.${CenterFormFields.FIFTH_TENTH_GRADE}.${CenterFormFields.LESSON_DURATION}`
                                    )}
                                    schoolLessons={getSchoolLessons(CenterFormFields.FIFTH_TENTH_GRADE, hospitalIndex)}
                                />
                            </>
                        );
                    }}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
    );
};
